import React from 'react';
import cn from 'classnames';

interface ShinyTextProps {
  text: string;
  disabled?: boolean;
  speed?: number;
  className?: string;
  tint?: string;
}

/**
 * Sweeps a highlight across text using compositor-friendly transform
 * animations instead of mask-position (which triggers main-thread repaints).
 *
 * Outer wrapper masks a band of the overlay; inner text counter-translates
 * so it stays visually aligned with the base text while the mask sweeps.
 */
function ShinyTextComponent({
  text,
  disabled = false,
  speed = 5,
  className = '',
  tint,
}: ShinyTextProps) {
  const overlayColor = tint ? `rgba(${tint}, 0.8)` : 'color-mix(in srgb, currentColor, white 50%)';
  const duration = `${speed}s`;

  return (
    <span className={cn('relative inline-block', className)}>
      {text}
      {!disabled && (
        <span aria-hidden="true" className="absolute inset-0 pointer-events-none overflow-hidden">
          <span
            className="block size-full"
            style={{
              WebkitMaskImage:
                'linear-gradient(120deg, transparent 20%, black 50%, transparent 80%)',
              maskImage: 'linear-gradient(120deg, transparent 20%, black 50%, transparent 80%)',
              animation: `shine-sweep ${duration} linear infinite`,
            }}
          >
            <span
              className="block"
              style={{
                color: overlayColor,
                animation: `shine-sweep-counter ${duration} linear infinite`,
              }}
            >
              {text}
            </span>
          </span>
        </span>
      )}
    </span>
  );
}

export const ShinyText = React.memo(ShinyTextComponent);
